import * as React from "react";

class PermissionButton extends waffle.base.BaseComponent {
    getDefaultState() {
        return $.extend(super.getDefaultState(), {
            hasPermission: false
        });
    }

    componentWillMount() {
        this.checkPermissionAccess();
    }

    render() {
        return this.toggleButton();
    }

    toggleButton() {
        if (this.state.hasPermission) {
            // This is a bit of a hack. We need this to look like the buttons that are used by Waffle, so we
            // actually style an href
            return (
                <a
                    className='btn ladda-button btn-warning'
                    onClick={() => this.apiCall()}
                    data-style='zoom-out' data-spinner-size='32'
                >
                    <span className='ladda-label'>{this.props.label}</span>
                    <span className='ladda-spinner'></span>
                </a>
            );
        }
        return <div/>;
    }

    apiCall() {
        radio('showLoader').broadcast();
        $.ajax({
            url: this.props.api_url,
            type: this.props.api_method
        }).done((response) => {
            if (response.status === 200) {
                location.reload();
            } else {
                radio('showAlert').broadcast('danger', response.message);
            }
        }).fail((unused, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
        });
    }

    checkPermissionAccess() {
        radio('showLoader').broadcast();
        $.ajax({
            url: `/api/users/hasRole/${this.props.role_name}`,
            type: 'GET'
        }).done((response) => {
            radio('hideLoader').broadcast();
            this.setState({
                hasPermission: response.status === 200
            })
        }).fail((unused, textStatus) => {
            radio('hideLoader').broadcast();
            radio('showAlert').broadcast('danger', textStatus);
        })
    }
}
module.exports = {
    PermissionButton
};
